import type { ThemeOptions } from '@mui/material/styles'

export const ThemeOverrides: ThemeOptions = {
  typography: {
    h1: { fontWeight: 300 },
    h2: { fontWeight: 300 },
    h3: { fontWeight: 300 },
    h4: { fontWeight: 300 },
    h5: { fontWeight: 300 },
    h6: { fontWeight: 300 },
    body1: { fontWeight: 300 },
    body2: { fontWeight: 300 },
    button: { fontWeight: 400 },
  },
  components: {
    MuiLink: {
      defaultProps: {
        color: 'inherit', underline: 'none', fontWeight: 300,
      },
    },
  },
}
